import React, { useEffect, useState } from 'react';
import './news.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/UseAuthContext';
import Loader from '../../Components/Loader/Loader';
import api from '../../api';
import Header from '../../Components/Header/Header';


function News() {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate  = useNavigate();
    const { user } = useAuthContext();

    useEffect(() => {
        api.get(`/news`, {
            headers: {
                Authorization: `Bearer ${user.token}`,
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            console.log("response", response.data);
            setNews(response.data);
            setLoading(false);
        })
        .catch(error => {
            console.error("Error fetching news:", error);
            setLoading(false);
        });
    }, [user.token]); // Added user.token dependency for better reactivity.

    const handleClick = (id) => {
        console.log(id);
        navigate(`/news-script/${id}`);
    };

    const formatDateTime = (isoString) => {
        if (!isoString) return { day: "", month: "", time: "" };
        const date = new Date(isoString);
        const day = date.getDate().toString().padStart(2, "0"); // 08
        const month = date.toLocaleString("en-US", { month: "short" }); // Feb
        const time = date.toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        return { day, month, time };
    };

    return (
        <div className='overall-news'>
            <Header />
            <div className='news'>
            <div className="news-header">
                <h2>Latest Updates</h2>
                <div className="news-sets">
                    {loading ? (
                        <p>Loading news...</p>
                    ) : (
                        news?.articles?.length > 0 ? (
                            news?.articles?.map((post,index) => {
                                const { day, month } = formatDateTime(post.publish_date); // Store formatted date
                                return (
                                    <div key={index} className="single-news">
                                        <div className="date">
                                            <span className="day">{day}</span>
                                            <span className="month">{month}</span>
                                        </div>
                                        <h3>{post.title}</h3>
                                        <button onClick={() => handleClick(post._id)}>Select</button>
                                    </div>
                                );
                            })
                        ) : (
                            <p>No news available.</p>
                        )
                    )}
                </div>
            </div>
            {
                loading&&(
                    <Loader/>
                )
            }
        </div>
        </div>
    );
}

export default News;
